'use client';
import { useDispatch } from 'react-redux';
import { UsersActions } from '@store/users/users-action';
import { Chip } from '@pezeshk-book/ui-kit';
import React from 'react';
import { FilterTagProps } from './filter-tag.props';

const FilterTag = ({ type, item }: FilterTagProps) => {
  const dispatch = useDispatch();

  const deleteFilterTagHandler = () => {
    dispatch(UsersActions.deleteFilterTag({ key: type }));
  };

  if (!item?.id && !item?.value) {
    return null;
  }

  return (
    <Chip
      className={'z-10 whitespace-nowrap text-ellipsis'}
      color={'danger'}
      rounded={'medium'}
      value={item?.value}
      onClick={deleteFilterTagHandler}
      onDelete={deleteFilterTagHandler}
      variant={'outlined'}
    />
  );
};

export default FilterTag;
